<div class="container-fluid">
 
    <!-- Page Heading -->
    <h1 class="h3 mb-2 text-gray-800">
      <i class="fas fa-user"></i> <!-- Icon for the title -->
      {{ memberI18n.allTitleI18n }}
    </h1>
    <p class="mb-4 text-muted">
      Mô-đun Quản Lý Thành Viên cho phép quản trị viên giám sát và quản lý tất cả các thành viên trong hệ thống. Bạn có thể xem danh sách chi tiết các thành viên, thêm thành viên mới, chỉnh sửa thông tin thành viên hiện có và xóa thành viên khi cần. Mô-đun này cung cấp giao diện toàn diện để duy trì cơ sở dữ liệu thành viên có tổ chức và hiệu quả, đảm bảo hoạt động trơn tru và hồ sơ luôn được cập nhật.
    </p>

    <!-- DataTales Example -->
    <div class="card mb-4">
      <div class="card-body">
        <div class="table-responsive">
          <button
          href="#add"
          role="button"
          data-toggle="modal"
          class="btn btn-outline-success btn-icon-split"
        >
          <span class="icon text-success">
            <i class="fas fa-plus"></i>
          </span>
          <span class="text">Tạo Mới</span>
        </button>

        <button
        href="#"
        role="button"
        class="btn btn-outline-warning btn-icon-split"
        (click)="getAll()"
      >
        <span class="icon text-warning">
          <i class="fas fa-redo"></i>
        </span>
        <span class="text">Tải Lại</span>
      </button>

      
      <div class="container mt-5">

        <div class="row">
            <!-- New Arrivals -->
            <div class="col-md-3 mb-4">
                <div class="card text-center border">
                    <div class="card-body">
                        <h5 class="card-title text-info">Thành Viên Mới</h5>
                        <p class="card-text h4">
                            <span *ngIf="newArrivals">{{ newArrivals }}</span>
                            <span *ngIf="!newArrivals">Đang Tải...</span>
                        </p>
                    </div>
                </div>
            </div>
      
            <!-- Blacklist -->
            <div class="col-md-3 mb-4">
                <div class="card text-center border">
                    <div class="card-body">
                        <h5 class="card-title text-danger">Danh Sách Đen</h5>
                        <p class="card-text h4">
                            <span *ngIf="blacklist">{{ blacklist }}</span>
                            <span *ngIf="!blacklist">Đang Tải...</span>
                        </p>
                    </div>
                </div>
            </div>
      
            <!-- Unverified -->
            <div class="col-md-3 mb-4">
                <div class="card text-center border">
                    <div class="card-body">
                        <h5 class="card-title text-warning">Người Dùng Chưa Xác Minh</h5>
                        <p class="card-text h4">
                            <span *ngIf="unverified">{{ unverified }}</span>
                            <span *ngIf="!unverified">Đang Tải...</span>
                        </p>
                    </div>
                </div>
            </div>
      
            <!-- Expired Users -->
            <div class="col-md-3 mb-4">
                <div class="card text-center border">
                    <div class="card-body">
                        <h5 class="card-title text-secondary">Người Dùng Hết Hạn</h5>
                        <p class="card-text h4">
                            <span *ngIf="expired">{{ expired }}</span>
                            <span *ngIf="!expired">Đang Tải...</span>
                        </p>
                    </div>
                </div>
            </div>
        </div>
      </div>

      <div *ngIf="loading; else loaded">
        <div class="d-flex justify-content-center">
          <div class="spinner-border text-primary" role="status">
            <span class="sr-only">Loading...</span>
          </div>
        </div>
      </div>























































      <ng-template #loaded>
          <app-member-list
            (editEvent)="edit($event)"
            (viewEvent)="view($event)"
            (deleteEvent)="delete($event)"
            [members]="members$"
            [memberI18n]="memberI18n"
          ></app-member-list>
           <app-member-modal
            [memberI18n]="memberI18n"
            [id]="id"
          ></app-member-modal>
      </ng-template>    
        </div>
      </div>
    </div>
</div>

